var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 13.4593C12.74 13.4593 13.3399 12.8594 13.3399 12.1193C13.3399 11.3792 12.74 10.7793 11.9999 10.7793C11.2599 10.7793 10.6599 11.3792 10.6599 12.1193C10.6599 12.8594 11.2599 13.4593 11.9999 13.4593Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.43976C12.74 8.43976 13.3399 7.83983 13.3399 7.09977C13.3399 6.3597 12.74 5.75977 11.9999 5.75977C11.2599 5.75977 10.6599 6.3597 10.6599 7.09977C10.6599 7.83983 11.2599 8.43976 11.9999 8.43976Z",
    fill: "#BBBBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 18.4691C12.74 18.4691 13.3399 17.8691 13.3399 17.1291C13.3399 16.389 12.74 15.7891 11.9999 15.7891C11.2599 15.7891 10.6599 16.389 10.6599 17.1291C10.6599 17.8691 11.2599 18.4691 11.9999 18.4691Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.92ca5d1b9e4a13b3d5dd1c791383813f.svg";
export { ForwardRef as ReactComponent };